import { Injectable } from '@angular/core';
import { catchAndGetFromFailureRxOp } from '@geekbears/gb-ngrx-stack-base';
import { SuperAdminHomeActions } from '@modules/super-admin/superadmin-home/aplication/store/superadmin-home.actions';
import { Actions, createEffect, EffectsModule, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs';
import { CompanyServices } from '../../domain/services/company.service';
import { CompanyActions } from './company.actions';

@Injectable()
export class CompanyEffects {
  constructor(
    private actions$: Actions,
    private companyService: CompanyServices
  ) {}

  allCompanies$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CompanyActions.getAllCompanies),
      mergeMap((action) => {
        const {type, ...params} = action
        return this.companyService.getAllCompanies(params).pipe(
          map((companies) =>
            CompanyActions.getAllCompaniesSuccess({ companies })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            CompanyActions.getAllCompaniesFailure({ failure })
          )
        );
      })
    );
  });
  deleteCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CompanyActions.deleteCompany),
      mergeMap((action) => {
        return this.companyService.deleteCompany(action.companyId).pipe(
          map((response) => CompanyActions.deleteCompanySuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            CompanyActions.deleteCompanyFailure({ failure })
          )
        );
      })
    );
  });

  companyById$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CompanyActions.getCompanyById),
      mergeMap((action) => {
        return this.companyService.getCompanyById(action.companyId).pipe(
          map((company) => CompanyActions.getCompanyByIdSuccess({ company })),
          catchAndGetFromFailureRxOp((failure) =>
            CompanyActions.getCompanyByIdFailure({ failure })
          )
        );
      })
    );
  });

  updateCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CompanyActions.updateCompany),
      mergeMap((action) => {
        return this.companyService
          .updateCompany(action.companyId, action.company)
          .pipe(
            map((response) =>
              CompanyActions.updateCompanySuccess({ response })
            ),
            catchAndGetFromFailureRxOp((failure) =>
              CompanyActions.updateCompanyFailure({ failure })
            )
          );
      })
    );
  });
  removeMember$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CompanyActions.removeMember),
      mergeMap((action) => {
        return this.companyService.removeMember(action.memberId).pipe(
          map((response) => CompanyActions.removeMemberSuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            CompanyActions.removeMemberFailure({ failure })
          )
        );
      })
    );
  });
  getMemberById$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CompanyActions.getMemberById),
      mergeMap((action) => {
        return this.companyService.getMemberById(action.memberId).pipe(
          map((response) => CompanyActions.getMemberByIdSuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            CompanyActions.getMemberByIdFailure({ failure })
          )
        );
      })
    );
  });
  sendInvoice$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CompanyActions.sendInvoice),
      mergeMap((action) => {
        return this.companyService.sendInvoice(action.companyId).pipe(
          map((response) => CompanyActions.sendInvoiceSuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            CompanyActions.sendInvoiceFailure({ failure })
          )
        );
      })
    );
  });
  history$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CompanyActions.paymentHistory),
      mergeMap((action) => {
        return this.companyService.paymentHistory(action.companyId).pipe(
          map((response) => CompanyActions.paymentHistorySuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            CompanyActions.paymentHistoryFailure({ failure })
          )
        );
      })
    );
  });
  addCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CompanyActions.addCompany),
      mergeMap((action) => {
        return this.companyService.addCompany(action.company).pipe(
          map((response) => CompanyActions.addCompanySuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            CompanyActions.addCompanyFailure({ failure })
          )
        );
      })
    );
  });
  contactCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CompanyActions.contactCompany),
      mergeMap((action) => {
        return this.companyService.contactCompany(action.companyId).pipe(
          map((response) => CompanyActions.contactCompanySuccess({ response })),
          catchAndGetFromFailureRxOp((failure) =>
            CompanyActions.contactCompanyFailure({ failure })
          )
        );
      })
    );
  });
  validateCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CompanyActions.validateCompany),
      mergeMap((action) => {
        return this.companyService.validateCompany(action.companyName).pipe(
          map((response) =>
            CompanyActions.validateCompanySuccess({ response })
          ),
          catchAndGetFromFailureRxOp((failure) =>
            CompanyActions.validateCompanyFailure({ failure })
          )
        );
      })
    );
  });
}
export const CompanyEffectsModule = EffectsModule.forFeature([CompanyEffects]);
